


class BulkSelection
extends HTMLElement {

    controller = new AbortController

    connectedCallback (){

        const quantity = this.queryQuantity()

        const inputs = this
            .querySelectorAll(`input[ name = bulk_prices ]`)

        const { signal } = this.controller

        inputs.forEach(( input ) => {

            this.updateInput(input,quantity)

            input.addEventListener('change',
                () => this.onChange(input),
                { signal })

            input.addEventListener('Check',
                () => this.onCheck(input),
                { signal })
        })
    }

    disconnectedCallback (){
        this.controller.abort()
    }

    queryQuantity (){

        const parent = this
            .closest(`.product-content-container`)

        const wrapper = parent
            .querySelector(`.product-form__quantity`)

        const input = wrapper
            .querySelector(`input[ name = quantity ]`)

        return Number( input.value )
    }

    updateInput ( input , quantity ){

        const threshold = Number( input.dataset.quantity )

        const overThreshold = ( quantity >= threshold )

        input.checked = overThreshold

        if( overThreshold )
            this.onCheck(input)
    }

    onCheck ( input ){

        if( ! input.checked )
            return

        // console.debug('Bulk-Selection::onCheck',input.dataset.quantity)

        this.updatePrice(input)
    }

    onChange ( input ){

        if( ! input.checked )
            return

        // console.debug('Bulk-Selection::onChange',input.dataset.quantity)

        const quantity = parseInt(input.dataset.quantity)

        this.updateQuantity(quantity)

        this.updatePrice(input)
    }

    updatePrice ( input ){

        const { originalPrice , currency , sectionId } = this

        const discount = parseFloat(input.value) * 0.01

        const discountedPrice = originalPrice * ( 1 - discount )

        const formattedPrice = this.formatPrice(discountedPrice,currency)

        const parentElement = document
            .getElementById(`price-${ sectionId }`)

        const targetChild = parentElement
            .querySelector(`.price`)
            .querySelector(`span`)

        false && console.debug('Formatted',{
            formattedPrice ,
            originalPrice ,
            discount ,
            discountedPrice
        })

        targetChild.innerText = formattedPrice

        const kilo = parentElement.parentElement.parentElement
            .querySelector('.Kilo-Price')

        const data = input.parentElement
            .querySelector(`#${ input.id } ~ .Bulk-Selection-Price .Bulk-Price-Unit`)

        if( kilo && data )
            kilo.innerText = data.innerText
    }

    updateQuantity ( value ){

        const event = new CustomEvent('product:quantity:set',{
            detail : { value }
        })

        window.dispatchEvent(event)
    }

    formatPrice ( price , currency ){

        const formatter = new Intl.NumberFormat('de-DE',{
            minimumFractionDigits : 2 ,
            maximumFractionDigits : 2 ,
            currencyDisplay : 'symbol' ,
            currencySign : 'standard' ,
            currency : currency ,
            style : 'currency'
        })

        return formatter.format(price)
    }

    get originalPrice (){
        return parseInt(this.dataset.originalPrice) * 0.01
    }

    get currency (){
        return this.dataset.currency
    }

    get sectionId (){
        return this.dataset.sectionId
    }
}


customElements.define(
    'bulk-selection' ,
    BulkSelection
)

